import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./CardsGraph.css";
import { Oval } from "react-loader-spinner";

const Card = ({
  status,
  count,
  onClick,
  icon,
  progress,
  color: customColor,
  style = {},
}) => {
  const getColorByStatus = (status) => {
    switch (status.toLowerCase()) {
      case "activo":
        return "green";
      case "proceso de integración":
      case "en proceso":
        return "orange";
      case "inactivo":
        return "red";
      case "sin capacidad":
        return "gray";
      default:
        return "#3b82f6"; // color por defecto
    }
  };
  const color = customColor || getColorByStatus(status);
  return (
    <div
      style={style}
      className="container-card-graph"
      onClick={() => onClick(status)}
    >
      <div className="d-flex container-card-graph-title ">
        <h3 className="mr-2">
          {count !== undefined || count !== null ? (
            count
          ) : (
            <div>
              {count !== 0 && (
                <Oval
                  visible={true}
                  height="40"
                  width="40"
                  color="#4fa94d"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              )}
            </div>
          )}
        </h3>

        <div
          style={{
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {progress !== undefined ? (
            <CircularProgressbar
              value={progress}
              text={`${progress}%`}
              styles={buildStyles({
                pathColor: color,
                textColor: "#000",
                trailColor: "#d6d6d6",
              })}
            />
          ) : (
            icon && (
              <img
                src={icon}
                alt={status}
                style={{ width: "30px", height: "30px" }}
              />
            )
          )}
        </div>
      </div>
      <p>{status}</p>
    </div>
  );
};

export default Card;
